<template>
  <b-container>
    <div>
      <h5 id="title" :contenteditable="canEdit">{{article.articleTitle}}</h5>
      <div>
        <span class="text-primary cursor" @click="goEdit" v-if="!isEdit">编辑</span>
        <span class="text-primary cursor" @click="postEdit" v-else>保存</span>
        <span class="text-danger cursor" @click="getDelete(article._id)">删除</span>
      </div>
      <div class="mt-4">
        <img :src="article.ossUrl" alt="" style="width: 40%; margin: auto; display: block">
        <upload-img v-on:getOssUrl="getOssUrl" v-show="canEdit"></upload-img>
      </div>
      <p id="content" class="mt-4" style="white-space: pre-wrap; line-height: 30px;" :contenteditable="canEdit">{{article.articleContent}}</p>
    </div>
  </b-container>
</template>

<script>
  import deleteMixin from '../mixins/delete';
  import UploadImg from './tools/UploadImg';

  export default {
    name: 'ArticleDetail',
    components: {UploadImg},
    mixins: [deleteMixin],
    data() {
      return {
        detailUrl: this.getDomain() + 'article/detail',
        editUrl: this.getDomain() + 'article/edit',
        canEdit: false,
        isFocus: false,
        isEdit: false,
        article: {}
      }
    },
    methods: {
      getDetail() {
        this.__axios(this.detailUrl, {_id :this.$route.query._id}, this.handleDetail)
      },
      handleDetail(res) {
        this.article = res.data.data[2]
      },
      handleDelete() {
        this.$router.push('/index/list')
      },
      goEdit() {
        this.canEdit = true;
        this.isEdit = true;
      },
      postEdit() {
        this.article._id = this.$route.query._id;
        this.article.articleTitle = document.getElementById('title').innerText;
        this.article.articleContent = document.getElementById('content').innerText;
        this.__axios(this.editUrl, this.article, this.handleEdit)
      },
      handleEdit() {
        this.$message.success('修改成功');
        this.canEdit = this.isEdit = false;
        this.getDetail()
      },
      getOssUrl(url) {
        if (url) {
          this.article.ossUrl = url
        }
      }
    },
    created() {
      this.getDetail()
    }
  }
</script>

<style scoped>
  span{
    margin-right: 1vw;
  }
</style>
